
export class OccurenceStatus {
    id: number;
    name: string;
    updateDateTime: Date;
    activeStatusIndicator: number;

    constructor(id: number, name: string, updateDateTime: Date, activeStatusIndicator: number) {
        this.id = id;
        this.name = name;
        this.updateDateTime = updateDateTime;
        this.activeStatusIndicator = activeStatusIndicator;
    }

}